import { SeriesType } from "./types";
import { esgScores } from "common/esg-helpers";
export const getMinMax = (points) => {
    if (points.length <= 0) {
        return [0, 0];
    }
    const startFrom = points[0].dataX;
    const minMax = [startFrom, startFrom];
    points.forEach((point) => {
        if (point.dataX < minMax[0]) {
            minMax[0] = point.dataX;
        }
        if (point.dataX > minMax[1]) {
            minMax[1] = point.dataX;
        }
    });
    return minMax;
};
export const getBubblesData = (pts, colorSet) => {
    const arr = {};
    let hasColorDimension = false;
    pts.forEach((pt) => {
        if (pt.dataColor) {
            hasColorDimension = true;
            if (!arr[pt.dataColor]) {
                arr[pt.dataColor] = [];
            }
            arr[pt.dataColor].push(pt);
        }
    });
    if (!hasColorDimension) {
        arr[""] = pts;
    }
    const result = Object.entries(arr).map((scoreAndPoints) => ({
        data: scoreAndPoints[1].map((point) => ({ ...point, x: point.dataX, y: point.dataY, z: point.dataZ })),
        name: scoreAndPoints[0],
        showInLegend: pts.some((val) => val?.dataX !== 0 || val?.dataY !== 0 || val?.dataZ !== 0) && hasColorDimension,
        type: SeriesType.Bubble
    }));
    if (colorSet?.toLocaleLowerCase() === "esg") {
        result.sortESG((a) => a.name);
    }
    return [result, hasColorDimension];
};
export const getSeries = (inputSeries, colorSet) => {
    const arr = [];
    inputSeries.forEach((serie) => {
        const output = {
            data: serie.data.filter((c) => (c.x || c.x === 0) && (c.y || c.y === 0) && (c.z || c.z === 0)),
            id: serie.name,
            name: serie.name,
            showInLegend: serie.showInLegend,
            type: serie.type
        };
        if (colorSet?.toLocaleLowerCase() === "esg") {
            output.colorIndex = esgScores.indexOf(serie.name);
        }
        arr.push(output);
    });
    return arr;
};
